// src/_config/fb_config.ts
// ⚠️ ใส่ค่า encoded config ของ Firebase ที่นี่
// วิธี encode: btoa(value.split('').reverse().join(''))

export const fb_config = {
  a: process.env.REACT_APP_API_KEY, // apiKey
  b: process.env.REACT_APP_AUTH_DOMAIN, // authDomain
  c: process.env.REACT_APP_DATABASE_URL, // databaseURL
  d: process.env.REACT_APP_PROJECT_ID, // projectId
  e: process.env.REACT_APP_STORAGE_BUCKET, // storageBucket
  f: process.env.REACT_APP_MESSAGING_SENDER_ID, // messagingSenderId
  g: process.env.REACT_APP_APP_ID, // appId
}
